import { PageLayoutWidth } from '@ms/yammer-web-core-ui/dist/components/PageLayout';
import React, { ReactNode, useCallback } from 'react';

import AppHeaderStatic from '../../AppHeaderStatic';
import { useTeamsClientContext } from '../../TeamsClientProvider/hooks';
import VivaEngageAppHeader from '../../VivaEngageAppHeader';

type UseHeaderCallback = () => (width: PageLayoutWidth | undefined) => ReactNode;
export const useHeaderCallback: UseHeaderCallback = () => {
  const { shouldHideHeaders, shouldShowStaticAppHeader } = useTeamsClientContext();

  return useCallback(
    (width) => {
      if (!width || width === PageLayoutWidth.Small || shouldHideHeaders) {
        return null;
      }

      if (shouldShowStaticAppHeader) {
        return <AppHeaderStatic />;
      }

      return <VivaEngageAppHeader />;
    },
    [shouldHideHeaders, shouldShowStaticAppHeader]
  );
};
